import React, {Component} from "react"
import { Panel, Button, Col, Glyphicon } from "react-bootstrap"
import AscModal from "../Elements/Modal/Modal";
import "../Elements/FromGroup/form_select.css";
import InlineForm from "../Elements/FromGroup/InlineForm";
import SetDataWithSpeechBubble from "../Elements/AscElements/SetDataWithSpeechBubble";
import * as faIcon from "@fortawesome/free-solid-svg-icons";

export default class ControlLogModal extends Component {
    copyRequestBody = () => {
        const { state, langText } = this.props;
        let requestBodyText = "";
        
        if (state.selected.request_body) {
            // 既にオブジェクトの場合はそのままJSON化
            if (typeof state.selected.request_body === 'object') {
                requestBodyText = JSON.stringify(state.selected.request_body, null, 2);
            } else {
                // 文字列の場合はそのまま使用
                requestBodyText = state.selected.request_body;
            }
        }
        
        navigator.clipboard.writeText(requestBodyText).then(() => {
            alert(langText.Message.RequestBodyCopied);
        }).catch(err => {
            console.error(err);
            alert(langText.Message.RequestBodyCopyFailed);
        });
    }

    getModalInfo = (modalType) => {
        let {
            langText,
            state,
            propSetState,
            closeModal,
        } = this.props;
        let info = null;

        switch (modalType) {
            case "controlLogDetail":
                info = (
                    <AscModal
                        state = {state}
                        propSetState = {propSetState}
                        langText = {langText}
                        customBtn1Func = {closeModal}
                        customBtn1Msg = {langText.Body.Close}
                        customBtn1Class = "close-execute"
                    >
                        {this.getItemInfo(modalType)}
                    </AscModal>
                );
                break;
        
            default:
                break;
        }

        return info;
    }

    getItemInfo = (modalType) => {
        const {
            langText,
            state,
            getMomentTime
        } = this.props;
        let info = null;

        switch (modalType) {
            case "controlLogDetail":
                info = (
                    <>
                        <Panel bsStyle="info">
                            <Panel.Heading>
                                <Panel.Title>
                                    <SetDataWithSpeechBubble
                                        displayData={langText.Body.controlLogDetailTitle}
                                        speechBubbleData={langText.Message.ControlLog_DetailTooltip}
                                        infoIconDisplayFlag={true}
                                        infoIconType={faIcon.faInfoCircle}
                                        infoIconClassName="modal-info-icon"
                                        infoIconColor="silver"
                                        infoIconSize="lg"
                                        custom="control-log-tooltip"
                                    />
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <InlineForm.static
                                    key = "id"
                                    controlId = "id"
                                    label = {langText.Body.Id}>
                                    {state.selected.id}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "company_name"
                                    controlId = "company_name"
                                    label = {langText.Body.CompanyName}>
                                    {state.selected.company_name}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "department_name"
                                    controlId = "department_name"
                                    label = {langText.Body.DepartmentName}>
                                    {state.selected.department_name}
                                </InlineForm.static>
                                
                                {state.selected.floor_name && (
                                    <InlineForm.static
                                        key = "floor_name"
                                        controlId = "floor_name"
                                        label = {langText.Body.FloorName}>
                                        {state.selected.floor_name}
                                    </InlineForm.static>
                                )}
                                
                                <InlineForm.static
                                    key = "display_user"
                                    controlId = "display_user"
                                    label = {langText.Body.ExecUser + "（メール）"}>
                                    {state.selected.exec_user + (state.selected.entry_user_email ? ` (${state.selected.entry_user_email})` : "")}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "created"
                                    controlId = "created"
                                    label = {langText.Body.ExecTime}>
                                    {state.selected.created ? getMomentTime({date: state.selected.created, format: "YYYY/MM/DD HH:mm:ss"}) : ""}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "menu_name"
                                    controlId = "menu_name"
                                    label = {langText.Body.MenuName}>
                                    {state.selected.menu_name}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "execution_detail"
                                    controlId = "execution_detail"
                                    label = {langText.Body.ExecutionDetail}>
                                    {state.selected.execution_detail}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "client_ip"
                                    controlId = "client_ip"
                                    label = "IP">
                                    {state.selected.client_ip}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "platform"
                                    controlId = "platform"
                                    label = "プラットフォーム">
                                    {state.selected.platform}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "browser"
                                    controlId = "browser"
                                    label = "ブラウザ">
                                    {state.selected.browser}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "resource"
                                    controlId = "resource"
                                    label = "リソース">
                                    {state.selected.resource}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "http_method"
                                    controlId = "http_method"
                                    label = "HTTP_METHOD">
                                    {state.selected.http_method}
                                </InlineForm.static>
                                
                                <InlineForm.static
                                    key = "status"
                                    controlId = "status"
                                    label = {langText.Body.Status}>
                                    {state.selected.status}
                                </InlineForm.static>
                                
                                <InlineForm
                                    key = "request_body"
                                    controlId = "request_body"
                                    label = {
                                        <Col sm={12} md={12} className="padding-0">
                                            <Col sm={6} md={6} className="padding-left-0">
                                                <strong>{langText.Body.RequestBody}</strong>
                                            </Col>
                                            <Col sm={6} md={6} className="text-right padding-right-0">
                                                <SetDataWithSpeechBubble
                                                    displayData={
                                                        <Button
                                                            bsSize="xs"
                                                            bsStyle="default"
                                                            onClick={this.copyRequestBody}
                                                        >
                                                            <Glyphicon glyph="copy" />
                                                        </Button>
                                                    }
                                                    speechBubbleData="コピー"
                                                    infoIconDisplayFlag={false}
                                                    custom="copy-button-tooltip"
                                                />
                                            </Col>
                                        </Col>
                                    }
                                    componentClass = "textarea"
                                    rows = "8"
                                    value = {
                                        state.selected.request_body 
                                        ? (typeof state.selected.request_body === 'object' 
                                            ? JSON.stringify(state.selected.request_body, null, 2)
                                            : state.selected.request_body)
                                        : ""
                                    }
                                    readOnly = {true}
                                />
                            </Panel.Body>
                        </Panel>
                    </>
                );
                break;
        
            default:
                break;
        }

        return info;
    }
    
    render() {
        let modalType = this.props.state.modalType;
        
        return (
            <>
                {this.getModalInfo(modalType)}
            </>
        );
    }
} 